import * as React from "react";
import {CrudPage} from "../crud/CrudPage";
import {observable} from "mobx";
import { FormStore } from "../../stores/FormStore";
import {CrudForm} from "../crud/CrudForm";
import {CrudList} from "../crud/CrudList";
import {Input} from "../form/fields/Input";
import {Field} from "../form/Field";
import {IWindow} from "../../index";
// import {UserForm} from "./UserPageModel";
import {BooleanRadios} from "../form/fields/BooleanRadios";
import {Col, Container, Row} from "reactstrap";
 import { Button} from "reactstrap";
import {Select} from "../form/fields/Select";
import {api} from "../../api";
import _ = require("lodash");
// import { Extension } from "typescript"; 

 import {getEnumOptions} from "../../utils/helper";
 import {enums} from "../../Enums";

 import {LGAPicker} from "../form/fields/LGAPicker";
 import {FederalConstituencyPicker} from "../form/fields/FederalConstituencyPicker";
 import {StateConstituencyPicker} from "../form/fields/StateConstituencyPicker";
 import {WardPicker} from "../form/fields/WardPicker";
 import {SenatorialDistrictPicker} from "../form/fields/SenatorialDistrictPicker";

 import {PollingUnitPicker} from "../form/fields/PollingUnitPicker";  
 import {ToastContainer} from 'react-toastify';
 import 'react-toastify/dist/ReactToastify.css';

const qs = require('qs');

const IWindow: IWindow = (window as IWindow);

/* =============== user form ======================================= */

 
export class UserFormData {
    @observable name = '';
    @observable role_id = '';
    @observable email = '';
    @observable phone_number = '';
    @observable password = '';
    @observable confirm_password = '';
    @observable is_active = true;
    @observable level = '';
    @observable local_government_areas = [];
    @observable wards = [];
    @observable states = [];
    @observable senatorial_districts = [];
    @observable federal_constituencies = [];
    @observable state_constituencies = [];
    @observable ward_id = null;
    @observable ward = null;
    @observable local_government_area_id = null;
    @observable polling_unit_id = null;
    @observable polling_unit = null;
    @observable is_collation_user = false;
    @observable resetToken = false;
}


export class UserForm extends CrudForm {
    modelName = 'User';
    @observable candidates = null;
    @observable party_id =  IWindow.initialState.user.party_id;
    candidateIds :any = null;

    loadMoreData(props: any, module: any) {
        IWindow.initialState.user.party_id && api.candidate.getListAction({
            filters : {
                party_id: IWindow.initialState.user.party_id,
                active_subscription: 1,
                is_active: 1,
            }
        }).then((data: any) => {
            this.candidates = data;
            this.candidateIds  = _.map(data, 'id');
        });
    }

    stateDropDown() {
        return this.formStore.getValue('level') === 'state' ? <Field
            key={this.formStore.getValue('level') + 'state' +
            this.candidates
            }
            label="States"
            name="states"
            placeholder="Select States"
            component={Select}
            loadOptions={() => {
                return api.state.getListAction({
                    filters: {
                        party_id: this.party_id,
                        candidate_levels: this.candidates ? _.uniq(_.map(this.candidates, 'level')) : null,
                        candidateIds: this.candidates ? _.map(this.candidates, 'id') : null,
                        election_position_id: 1,
                    }
                });
            }}
            store={this.formStore}
            multi={true}
            valueObject={true}
        /> : ''
    };

    lgaDropDown() {
        return this.formStore.getValue('level') === 'lga' ?
            <Field
                key={
                    'lga-drop' + this.formStore.getValue('level') +
                    this.candidates
                }
                label="Local Government Areas"
                placeholder="Local Government Areas"
                name="local_government_areas"
                store={this.formStore}
                component={LGAPicker}
                filters={{
                    party_id: this.party_id,
                    candidate_levels: this.candidates ? _.uniq(_.map(this.candidates, 'level')) : null,
                    candidateIds: this.candidates ? _.map(this.candidates, 'id') : null,
                    election_position_id: 1,
                    is_active: 1
                }}
            /> : ''
    };

    wardsDropDown() {
        return this.formStore.getValue('level') == 'ward' ?
            <Field
                key={this.formStore.getValue('level') + this.candidates + 'ward' }
                label="Ward"
                name="wards"
                placeholder="Wards"
                store={this.formStore}
                component={WardPicker}
                filters={{
                    party_id: this.party_id,
                    candidate_levels: this.candidates ? _.uniq(_.map(this.candidates, 'level')) : null,
                    candidateIds: this.candidates ? _.map(this.candidates, 'id') : null,
                    election_position_id: 1,
                    is_active:1
                }}
            /> : ''
    }

    senatorialDistrictDropDown() {
        return this.formStore.getValue('level') === 'senatorial_district' ?
            <Field
                key={'sd-drop' +
                this.formStore.getValue('level')}
                label="Senatorial Districts"
                name="senatorial_districts"
                placeholder="Select Senatorial Districts"
                store={this.formStore}
                component={SenatorialDistrictPicker}
                filters={{
                    party_id: this.party_id,
                    level: this.formStore.getValue('level'),
                    candidateIds: this.candidateIds,
                    election_position_id: 1,
                    is_active:1
                }}
            /> : ''

    }

    federalConstituencyDropDown() {
        return this.formStore.getValue('level') === 'federal_constituency' ?
            <Field
                key={'fc-drop' +
                this.formStore.getValue('level') }
                label="Federal Constituencies"
                name="federal_constituencies"
                placeholder="Select Federal Constituencies"
                store={this.formStore}
                component={FederalConstituencyPicker}
                filters={{
                    party_id: this.party_id,
                    level: this.formStore.getValue('level'),
                    candidateIds: this.candidateIds,
                    election_position_id:1,
                    is_active:1,
                }}
            /> : ''
    }

    stateConstituencyDropDown() {
        return this.formStore.getValue('level') === 'state_constituency' ?
            <Field
                key={'sc-drop' +
                this.formStore.getValue('level')
                }
                label="State Constituencies"
                name="state_constituencies"
                placeholder="Select State Constituencies"
                store={this.formStore}
                component={StateConstituencyPicker}
                filters={{
                    party_id: this.party_id,
                    level: this.formStore.getValue('level'),
                    candidateIds: this.candidateIds,
                    election_position_id:1,
                    is_active:1
                }}
            /> : ''
    }

    pollingUnitDropDown(){
        return this.formStore.getValue('level') === 'polling_unit' ?
            <>
                <Field
                    key={this.formStore.getValue('level') + 'ward_picker'}
                    label="Ward"
                    multi={false}
                    name="ward"
                    placeholder="Ward"
                    store={this.formStore}
                    component={WardPicker}
                    filters={{
                        candidate_levels: this.candidates ? _.uniq(_.map(this.candidates, 'level')) : null,
                        candidateIds: this.candidates ? _.map(this.candidates, 'id') : null,
                        is_active: 1,
                    }}
                    onChange={(value: any) => {
                        this.formStore.setValue('ward_id', value.id);
                        this.formStore.setValue('polling_unit_id', null);
                    }}
                />
                { this.formStore.getValue('ward_id')  &&
                <Field
                    key={this.formStore.getValue('ward_id') + this.formStore.getValue('level') + 'polling-unit-drop'}
                    label="Polling Unit"
                    name="polling_unit"
                    placeholder="Search Polling Unit"
                    component={PollingUnitPicker}
                    filters={{
                        ward_id: this.formStore.getValue('ward_id')
                    }}
                    multi={false}
                    store={this.formStore}
                    onChange={(value: any) => {
                        this.formStore.setValue('polling_unit_id', value.id);
                    }}
                /> }
            </> : ''
    }

    getData = async () => {
        if (this.id) {
            this.isLoading = true;
            await api.user.getDetailAction(this.id, null).then((data: any) => {
                this.formStore.setData(data.data);
                this.entity = data.data;
            });
            this.isLoading = false;
        } else {
            this.isLoading = false;
        }
    };

    handleChange = () => {
        this.formStore.setValue('resetToken', false);
        if(this.formStore.getValue('is_active') === false){
           if(confirm('Are you sure you want in active user,which will reset mobile user local data?')){
               this.formStore.setValue('resetToken', true);
           }else{
               this.formStore.setValue('is_active', true);
           }
        }
    }

    renderFieldsData() {
        return (
            <>
                <Field
                    label="Name"
                    name="name"
                    component={Input}
                    required={true}
                    autocomplete="off"
                    store={this.formStore}
                />

                <Field
                    label="Role"
                    name="role_id"
                    component={Select}
                    required={true}
                    loadOptions={api.role.getListAction}
                    store={this.formStore}
                />

                <Field
                    label="Email"
                    name="email"
                    type="email"
                    component={Input}
                    autocomplete="off"
                    store={this.formStore}
                />

                <Field
                    label="Phone number"
                    name="phone_number"
                    component={Input}
                    required={true}
                    autocomplete="off"
                    store={this.formStore}
                />

                <Field
                    label="Password"
                    name="password"
                    type="password"
                    component={Input}
                    store={this.formStore}
                />

                <Field
                    label="Confirm Password"
                    name="confirm_password"
                    type="password"
                    component={Input}
                    store={this.formStore}
                />

                {
                    IWindow.initialState.user.party_id ?
                        <Field
                            label="Level"
                            name="level"
                            placeholder="Select Level"
                            component={Select}
                            options={_.remove(getEnumOptions(enums.userLevel), (level) => {
                            return level.value !== 'superadmin';
                        })}
                            store={this.formStore}
                            onChange={(value:any) => {
                                this.formStore.setValue('local_government_areas', []);
                                this.formStore.setValue('states', []);
                                this.formStore.setValue('wards', []);
                                this.formStore.setValue('senatorial_districts', []);
                                this.formStore.setValue('federal_constituencies', []);
                                this.formStore.setValue('state_constituencies', []);
                              //  this.formStore.setValue('polling_unit_id', null);
                                this.formStore.setValue('ward', null);
                                if(value === 'poling_unit'){
                                    this.formStore.setValue('is_collation_user', true);
                                }else{
                                    this.formStore.setValue('is_collation_user', false);
                                }
                            }}
                        /> : ''

                }

                {
                    IWindow.initialState.user.party_id && this.formStore.getValue('level') &&
                    this.formStore.getValue('level') !== 'party'
                        ?
                        <>
                            {
                                this.formStore.getValue('level') !== 'polling_unit' ?
                                <Field
                                    name="is_collation_user"
                                    component={BooleanRadios}
                                    trueLabel="Collation"
                                    falseLabel="Non-collation"
                                    store={this.formStore}
                                    helpText="Note: only collation user can login in mobile, only allowed to select single region"

                                /> : ''
                            }

                            {this.stateDropDown()}

                            {this.lgaDropDown()}

                            {this.wardsDropDown()}

                            {this.senatorialDistrictDropDown()}

                            {this.federalConstituencyDropDown()}

                            {this.stateConstituencyDropDown()}

                            {this.pollingUnitDropDown()}
                        </> : ''
                }

                <Field
                    name="is_active"
                    component={BooleanRadios}
                    trueLabel="Active"
                    falseLabel="In-Active"
                    store={this.formStore}
                    onChange={this.handleChange}
                />
            </>
        );
    }
}


/* =============== user form end =================================== */

 export class PartyElectionPollingUnitFormData {
    // @observable name = '';
	
	  @observable name = '';
    @observable role_id = '';
    @observable email = '';
    @observable phone_number = '';
    @observable password = '';
    @observable confirm_password = '';
    @observable is_active = true;
    @observable level = '';
    @observable local_government_areas = [];
    @observable wards = [];
    @observable states = [];
    @observable senatorial_districts = [];
    @observable federal_constituencies = [];
    @observable state_constituencies = [];
    @observable ward_id = null;
    @observable ward = null;
    @observable local_government_area_id = null;
    @observable polling_unit_id = null;
    @observable polling_unit = null;
    @observable is_collation_user = false;
    @observable resetToken = false;
	
	
}
 
export class PartyElectionPollingUnitForm extends  CrudForm  {

    /*
    modelName = 'PartyElectionPollingUnit';

    renderFields() {
        return (
            <>
                <Field
                    label="Name"
                    name="name"
                    component={Input}
                    required={true}
                    store={this.formStore}
                />
            </>
        );
    } */
	
	 modelName = 'User';
    @observable candidates = null;
    @observable party_id =  IWindow.initialState.user.party_id;
    candidateIds :any = null;
	
	loadMoreData(props: any, module: any) {
	
		if (window.localStorage.getItem('level') != '') {
			this.formStore.setValue('level', window.localStorage.getItem('level'));    
			this.formStore.setValue('ward', window.localStorage.getItem('ward'));    
			this.formStore.setValue('ward_id', window.localStorage.getItem('ward_id'));
			
			this.formStore.setValue('polling_unit', window.localStorage.getItem('polling_unit'));
			this.formStore.setValue('polling_unit_id', window.localStorage.getItem('polling_unit_id'));

		
			
		}
		console.log("datsdfsfdsdf",this.formStore.getValue('ward'));
		   
        IWindow.initialState.user.party_id && api.candidate.getListAction({
            filters : {
                party_id: IWindow.initialState.user.party_id,
                active_subscription: 1,
                is_active: 1,
            }
        }).then((data: any) => {
            this.candidates = data;
            this.candidateIds  = _.map(data, 'id');
        });
		
		console.log("data sssss", this.formStore.getValue('level'));
		
    }

    stateDropDown() {
        return this.formStore.getValue('level') === 'state' ? <Field
            key={this.formStore.getValue('level') + 'state' +
            this.candidates
            }
            label="States"
            name="states"
            placeholder="Select States"
            component={Select}
            loadOptions={() => {
                return api.state.getListAction({
                    filters: {
                        party_id: this.party_id,
                        candidate_levels: this.candidates ? _.uniq(_.map(this.candidates, 'level')) : null,
                        candidateIds: this.candidates ? _.map(this.candidates, 'id') : null,
                        election_position_id: 1,
                    }
                });
            }}
            store={this.formStore}
            multi={true}
            valueObject={true}
        /> : ''
    };

    lgaDropDown() {
        return this.formStore.getValue('level') === 'lga' ?
            <Field
                key={
                    'lga-drop' + this.formStore.getValue('level') +
                    this.candidates
                }
                label="Local Government Areas"
                placeholder="Local Government Areas"
                name="local_government_areas"
                store={this.formStore}
                component={LGAPicker}
                filters={{
                    party_id: this.party_id,
                    candidate_levels: this.candidates ? _.uniq(_.map(this.candidates, 'level')) : null,
                    candidateIds: this.candidates ? _.map(this.candidates, 'id') : null,
                    election_position_id: 1,
                    is_active: 1
                }}
            /> : ''
    };

    wardsDropDown() {
        return this.formStore.getValue('level') == 'ward' ?
            <Field
                key={this.formStore.getValue('level') + this.candidates + 'ward' }
                label="Ward"
                name="wards"
                placeholder="Wards"
                store={this.formStore}
                component={WardPicker}
                filters={{
                    party_id: this.party_id,
                    candidate_levels: this.candidates ? _.uniq(_.map(this.candidates, 'level')) : null,
                    candidateIds: this.candidates ? _.map(this.candidates, 'id') : null,
                    election_position_id: 1,
                    is_active:1
                }} 
				
            /> : ''
    }

    senatorialDistrictDropDown() {
        return this.formStore.getValue('level') === 'senatorial_district' ?
            <Field
                key={'sd-drop' +
                this.formStore.getValue('level')}
                label="Senatorial Districts"
                name="senatorial_districts"
                placeholder="Select Senatorial Districts"
                store={this.formStore}
                component={SenatorialDistrictPicker}
                filters={{
                    party_id: this.party_id,
                    level: this.formStore.getValue('level'),
                    candidateIds: this.candidateIds,
                    election_position_id: 1,
                    is_active:1
                }}
            /> : ''

    }

    federalConstituencyDropDown() {
        return this.formStore.getValue('level') === 'federal_constituency' ?
            <Field
                key={'fc-drop' +
                this.formStore.getValue('level') }
                label="Federal Constituencies"
                name="federal_constituencies"
                placeholder="Select Federal Constituencies"
                store={this.formStore}
                component={FederalConstituencyPicker}
                filters={{
                    party_id: this.party_id,
                    level: this.formStore.getValue('level'),
                    candidateIds: this.candidateIds,
                    election_position_id:1,
                    is_active:1,
                }}
            /> : ''
    }

    stateConstituencyDropDown() {
        return this.formStore.getValue('level') === 'state_constituency' ?
            <Field
                key={'sc-drop' +
                this.formStore.getValue('level')
                }
                label="State Constituencies"
                name="state_constituencies"
                placeholder="Select State Constituencies"
                store={this.formStore}
                component={StateConstituencyPicker}
                filters={{
                    party_id: this.party_id,
                    level: this.formStore.getValue('level'),
                    candidateIds: this.candidateIds,
                    election_position_id:1,
                    is_active:1
                }}
            /> : ''
    }

    pollingUnitDropDown(){
        return this.formStore.getValue('level') === 'polling_unit' ?
            <>
                <Field
                    key={this.formStore.getValue('level') + 'ward_picker'}
                    label="Ward"
                    multi={false}
                    name="ward"
                    placeholder="Ward"
                    store={this.formStore}
                    component={WardPicker}
                    filters={{
                        candidate_levels: this.candidates ? _.uniq(_.map(this.candidates, 'level')) : null,
                        candidateIds: this.candidates ? _.map(this.candidates, 'id') : null,
                        is_active: 1,
                    }}
                    onChange={(value: any) => {
                        this.formStore.setValue('ward_id', value.id);
                        this.formStore.setValue('polling_unit_id', null);
                    }}
                />
                { this.formStore.getValue('ward_id')  &&
                <Field
                    key={this.formStore.getValue('ward_id') + this.formStore.getValue('level') + 'polling-unit-drop'}
                    label="Polling Unit"
                    name="polling_unit"
                    placeholder="Search Polling Unit"
                    component={PollingUnitPicker}
                    filters={{
                        ward_id: this.formStore.getValue('ward_id')
                    }}
                    multi={false}
                    store={this.formStore}
                    onChange={(value: any) => {
                        this.formStore.setValue('polling_unit_id', value.id);
                    }}
                /> }
            </> : ''
    }

    getData = async () => {
        if (this.id) {
            this.isLoading = true;
            await api.user.getDetailAction(this.id, null).then((data: any) => {
                this.formStore.setData(data.data);
                this.entity = data.data;
            });
            this.isLoading = false;
        } else {
            this.isLoading = false;
        }
    };

    handleChange = () => {
        this.formStore.setValue('resetToken', false);
        if(this.formStore.getValue('is_active') === false){
           if(confirm('Are you sure you want in active user,which will reset mobile user local data?')){
               this.formStore.setValue('resetToken', true);
           }else{
               this.formStore.setValue('is_active', true);
           }
        }
    }

    renderFields() {
        return (
            <>
                <Field
                    label="Name"
                    name="name"
                    component={Input}
                    required={true}
                    autocomplete="off"
                    store={this.formStore}
                />

                <Field
                    label="Role"
                    name="role_id"
                    component={Select}
                    required={true}
                    loadOptions={api.role.getListAction}
                    store={this.formStore}
                />

                <Field
                    label="Email"
                    name="email"
                    type="email"
                    component={Input}
                    autocomplete="off"
                    store={this.formStore}
                />

                <Field
                    label="Phone number"
                    name="phone_number"
                    component={Input}
                    required={true}
                    autocomplete="off"
                    store={this.formStore}
                />

                <Field
                    label="Password"
                    name="password"
                    type="password"
                    component={Input}
                    store={this.formStore}
                />

                <Field
                    label="Confirm Password"
                    name="confirm_password"
                    type="password"
                    component={Input}
                    store={this.formStore}
                />

                {
                    IWindow.initialState.user.party_id ?
                        <Field
						key={"form-field-level"}
                            label="Level"
                            name="level"
							disabled="true"
                            placeholder="Select Level"
                            component={Select}
                            options={_.remove(getEnumOptions(enums.userLevel), (level) => {
                            return level.value !== 'superadmin';
                        })}
                            store={this.formStore}
                            onChange={(value:any) => {
                                this.formStore.setValue('local_government_areas', []);
                                this.formStore.setValue('states', []);
                                this.formStore.setValue('wards', []);
                                this.formStore.setValue('senatorial_districts', []);
                                this.formStore.setValue('federal_constituencies', []);
                                this.formStore.setValue('state_constituencies', []);
                                this.formStore.setValue('polling_unit_id', null);
                                this.formStore.setValue('ward', null);
                                if(value === 'poling_unit'){
                                    this.formStore.setValue('is_collation_user', true);
                                }else{
                                    this.formStore.setValue('is_collation_user', false);
                                }
                            }}
                        /> : ''

                }
				
					 <Field
                    label="Ward"
                    name="ward"
					disabled="true"
                    component={Input}
                    store={this.formStore}
                />
				
				<Field
                    label="Polling Unit"
                    name="polling_unit"
					disabled="true"
                    component={Input}
                    store={this.formStore}
                />
			

                {
                    IWindow.initialState.user.party_id && this.formStore.getValue('level') &&
                    this.formStore.getValue('level') !== 'party'
                        ?
                        <>
                            {
                                this.formStore.getValue('level') !== 'polling_unit' ?
                                <Field
                                    name="is_collation_user"
                                    component={BooleanRadios}
                                    trueLabel="Collation"
                                    falseLabel="Non-collation"
                                    store={this.formStore}
                                    helpText="Note: only collation user can login in mobile, only allowed to select single region"

                                /> : ''
                            }

                            {this.stateDropDown()}

                            {this.lgaDropDown()}

                            { /* this.wardsDropDown() */}

                            {this.senatorialDistrictDropDown()}

                            {this.federalConstituencyDropDown()}

                            {this.stateConstituencyDropDown()}

                            {/* this.pollingUnitDropDown() */ }
                        </> : ''
                }

                <Field
                    name="is_active"
                    component={BooleanRadios}
                    trueLabel="Active"
                    falseLabel="In-Active"
                    store={this.formStore}
                    onChange={this.handleChange}
                />
            </>
        );
    }
	

}
 
export class PartyElectionPollingUnitFilterForm {
    @observable election_id = null;
    @observable user_party_id = IWindow.initialState.user.party_id;
    @observable election_position_id = null;
    @observable state_id = null;
    @observable local_government_area_id = null;
    @observable ward_id = null;
    @observable federal_constituency_id = null;
    @observable senatorial_district_id = null;
    @observable state_constituency_id = null;
    @observable level = null;
     candidateIds = null;
}



export class PartyElectionPollingUnitList extends CrudList /* CrudList */ {
    modelName = 'PartyElectionPollingUnit';
    @observable election: any = null;
    @observable candidates = null;
    @observable userForm: UserForm;
    @observable polluserForm:  PartyElectionPollingUnitFormData;
    @observable formStore: FormStore<any>;
	
	constructor(props: any) {
        super(props);
        this.handleExport = this.handleExport.bind(this);
     
    }
    
    getElectionDetails(electionId: any) {
        this.election = null;
        
        if(electionId){
            api.election.getDetailAction(electionId).then((data: any) => {
                this.election = data;
            })
        }
    }

    getCandidates() {
       api.candidate.getListAction({
            filters: {
                election_id: this.filterFormStore.getValue('election_id'),
                party_id: this.filterFormStore.getValue('user_party_id'),
                election_position_id: this.filterFormStore.getValue('election_position_id')
            }
        }).then((data: any) => {
           this.candidates = data;
           this.filterFormStore.setValue('candidateIds', _.map(data, 'id'));
        })
    }

    senatorialDistrictDropDown() {
        return this.filterFormStore.getValue('level') === 'senatorial_district' ?
            <Col md={2} lg={3} xl>
                <Field
                    key={ 'filter-sd-drop-' +
                        this.filterFormStore.getValue('election_id') +
                        this.filterFormStore.getValue('election_position_id') +
                        this.filterFormStore.getValue('user_party_id') +
                        this.filterFormStore.getValue('level') +
                        this.filterFormStore.getValue('state_id')
                    }
                    name="senatorial_district_id"
                    placeholder="Select Senatorial Districts"
                    component={Select}
                    valueObject={true}
                    loadOptions={() => {
                        return api.senatorialDistrict.getListAction({
                            filters: {
                                state_id: this.filterFormStore.getValue('state_id'),
                                election_id: this.filterFormStore.getValue('election_id'),
                                election_position_id: this.filterFormStore.getValue('election_position_id'),
                                level: this.filterFormStore.getValue('level'),
                                candidateIds: this.filterFormStore.getValue('candidateIds'),
                                party_id: this.filterFormStore.getValue('user_party_id'),
                            }
                        });
                    }}
                    store={this.filterFormStore}
                    onChange={() => {
                        this.filterFormStore.setValue('ward_id', null);
                        this.filterFormStore.setValue('local_government_area_id', null);
                    }}
                />
            </Col>: ''
    }

    federalConstituencyDropDown() {
        return this.filterFormStore.getValue('level') === 'federal_constituency' ?
            <Col md={2} lg={3} xl>
                <Field
                    key={ 'filter-fc-drop-' +
                    this.filterFormStore.getValue('election_id') +
                    this.filterFormStore.getValue('election_position_id') +
                    this.filterFormStore.getValue('user_party_id') +
                    this.filterFormStore.getValue('level') +
                    this.filterFormStore.getValue('state_id')
                    }
                    name="federal_constituency_id"
                    placeholder="Select Federal Constituency"
                    component={Select}
                    valueObject={true}
                    loadOptions={() => {
                        return api.federalConstituency.getListAction({
                            filters: {
                                state_id: this.filterFormStore.getValue('state_id'),
                                election_id: this.filterFormStore.getValue('election_id'),
                                election_position_id: this.filterFormStore.getValue('election_position_id'),
                                level: this.filterFormStore.getValue('level'),
                                candidateIds: this.filterFormStore.getValue('candidateIds'),
                                party_id: this.filterFormStore.getValue('user_party_id'),
                            }
                        });
                    }}
                    store={this.filterFormStore}
                    onChange={(item: any) => {
                        this.filterFormStore.setValue('ward_id', null);
                        this.filterFormStore.setValue('local_government_area_id', null);
                    }}
                />
            </Col>: ''
    }

    stateConstituencyDropDown() {
        return this.filterFormStore.getValue('level') === 'state_constituency' ?
            <Col md={2} lg={3} xl>
                <Field
                    key={ 'filter-sc-drop-' +
                    this.filterFormStore.getValue('election_id') +
                    this.filterFormStore.getValue('election_position_id') +
                    this.filterFormStore.getValue('user_party_id') +
                    this.filterFormStore.getValue('level') +
                    this.filterFormStore.getValue('state_id')
                    }
                    name="state_constituency_id"
                    placeholder="Select State Constituency"
                    component={Select}
                    valueObject={true}
                    loadOptions={() => {
                        return api.stateConstituency.getListAction({
                            filters: {
                                state_id: this.filterFormStore.getValue('state_id'),
                                election_id: this.filterFormStore.getValue('election_id'),
                                election_position_id: this.filterFormStore.getValue('election_position_id'),
                                level: this.filterFormStore.getValue('level'),
                                candidateIds: this.filterFormStore.getValue('candidateIds'),
                                party_id: this.filterFormStore.getValue('user_party_id'),
                            }
                        });
                    }}
                    store={this.filterFormStore}
                    onChange={(item: any) => {
                        this.filterFormStore.setValue('ward_id', null);
                    }}
                />
            </Col>: ''
    }


    colums() {
        return [
            {
                name: "polling_unit.station_number",
                label: "Station Number",
                sortColumn: 'station_number',
                sort: true,
            },
            {
                name: "polling_unit.state.code",
                label: "State Code",
                sort: true,
                sortColumn: 'state.code',
            },
            {
                name: "polling_unit.state.name",
                label: "State",
                sort: true,
                sortColumn: 'state.name',
            },
            {
                name: "polling_unit.local_government_area.code",
                label: "LGA Code",
                sort: true,
                sortColumn: 'local_government_area.code',
            },
            {
                name: "polling_unit.local_government_area.name",
                label: "LGA",
                sort: true,
                sortColumn: 'local_government_area.name',
            },
            {
                name: "polling_unit.ward.code",
                label: "Ward Code",
                sort: true,
                sortColumn: 'ward.code',
            },
            {
                name: "polling_unit.ward.name",
                label: "Ward",
                sort: true,
                sortColumn: 'ward.name',
            },
            {
                name: "code",
                label: "Polling Unit Code",
                sort: true,
                sortColumn: 'code',
            },
            {
                name: "name",
                label: "Polling Unit Name",
                sort: true,
                sortColumn: 'name',
            },
            {
                name: "registered_voters",
                label: "INEC Reg. Voters",
                sort: true,
                sortColumn: 'registered_voters',
            },
			{
                name: "pusers",
                label: "Agent Assigned",
                sort: true,
                sortColumn: 'pusers',
				formatter: (value: any, item: any) => {  
					return ( 
						<>						
								{value > 0 ? 'Yes' : 'No'}
							
						</>
					);
				},
            },
			{
                name: "noofvotescount",
                label: "Result Submitted",
                sort: true,
                sortColumn: 'noofvotescount',
				formatter: (value: any, item: any) => {  
					return ( 
						<>						
								{value > 0 ? 'Yes' : 'No'}
							
						</>
					);
				},
            },			
			{
                name: "registered_voters",
                label: "Actions",
				formatter: (value: any, item: any) => {  
                return ( 
                    <>						
                            <Button color="grid" /* onClick={() => this.props.onAdd()} */ onClick={() => this.addUser(item)} size="sm"
                                    className="btn btn-positions"><span className="icon-users"/></Button>
                        
                    </>
                );
            },
				
            },
        ];
    }
	addUser(item: any)
	{
		console.log("data" , item.registered_voters);
		window.localStorage.setItem('level', 'polling_unit');
		
		window.localStorage.setItem('ward_id', item.polling_unit.ward.id);
		
		// const wards = { id: item.polling_unit.ward.id, label: item.polling_unit.ward.name, value: item.polling_unit.ward.id };
		// window.localStorage.setItem('ward', JSON.stringify(wards));
		window.localStorage.setItem('ward', item.polling_unit.ward.name);
		
		window.localStorage.setItem('polling_unit', item.polling_unit.name);
		window.localStorage.setItem('polling_unit_id', item.polling_unit_id);
		
		
		this.props.onAdd();
	}

    idColumn() {
        return '';
    }

    /*  actions() {
        return ''
    }  */

    getUserPopup() {
       // console.log('click pressed');
        
        
        
     }

     defaultActions() {
		
        return {
            name: "id",
            label: "Actions",
            formatter: (value: any) => {  
                return ( 
                    <>
                        
			
                            
                        
                    </>
                );
            },
            style: {whiteSpace: 'nowrap', textAlign: 'center', display: 'none'},
        } 
    }

	handleExport = () => {
        let search = {
            filters: this.filterFormStore.data,
            export: true
        };
        window.location.href = '/api/party/polling-units?' + qs.stringify(search);
    };	

    renderTable() {
        if (this.filterFormStore.getValue('election_id')){
            return super.renderTable();
        }
        return <>{'Please select election first!'}</>;
    }

    onLoadElections = () => {
        return api.election.getListAction({
            filters: {
                party_id: this.filterFormStore.getValue('user_party_id'),
            }
        }).then((data: any) => {
            if (data && data.length) {
                this.filterFormStore.setValue('election_id', data[0].id);
            }
            return data;
        });
    };

    onLoadElectionPosition = () => {
        return this.filterFormStore.getValue('election_id')  && api.electionPosition.getListAction({
            filters: {
                election_id: this.filterFormStore.getValue('election_id'),
                party_id: this.filterFormStore.getValue('user_party_id')
            }
        }).then((data: any) => {
            if (data && data.length) {
                this.filterFormStore.setValue('election_position_id', data[0].id);
                this.filterFormStore.setValue('level', data[0].level);
            }
            return data;
        });
    }

    renderFilters() {
        return (
            <Container>
			<Row className="form-row">
                    <Col md={5}>
                        <ToastContainer autoClose={5000} />
                    </Col>
            </Row>
                <Row className="form-row">
                    <Col md={2} lg={3} xl>
                        <Field
                            key={'filer-election-' +
                                IWindow.initialState.user.party_id
                            }
                            placeholder="Select Election"
                            name="election_id"
                            component={Select}
                            required={true}
                            loadOptions={this.onLoadElections}
                            store={this.filterFormStore} 
                            onChange={(value: any) => {
                                this.getElectionDetails(value);
                                this.filterFormStore.setValue('level', null);
                                this.filterFormStore.setValue('election_position_id', null);
                                this.getCandidates();
                            }}
                        />
                    </Col>
                    { this.filterFormStore.getValue('election_id') ?
                    <Col md={2}>
                        <Field
                            key={'filer-election-position' +
                                this.filterFormStore.getValue('election_id')  +
                                this.filterFormStore.getValue('user_party_id')
                            }
                            placeholder="Position"
                            name="election_position_id"
                            component={Select}
                            required={true}
                            loadOptions={this.onLoadElectionPosition}
                            store={this.filterFormStore}
                            returnObject={true}
                            extraKey={'level'}
                            onChange={(item: any) => {
                                this.filterFormStore.setValue('level', null);
                                if(item){
                                    this.filterFormStore.setValue('level', item.extraKey);
                                }
                                this.filterFormStore.setValue('state_id', null);
                                this.filterFormStore.setValue('senatorial_district_id', null);
                                this.filterFormStore.setValue('federal_constituency_id', null);
                                this.filterFormStore.setValue('local_government_area_id', null);
                                this.filterFormStore.setValue('state_constituency_id', null);
                                this.filterFormStore.setValue('ward_id', null);
                            }}
                        />
                    </Col>
                    : '' }
                    {
                        this.filterFormStore.getValue('election_position_id') ?
                            <>

                                {
                                    this.filterFormStore.getValue('level') != "senatorial_district" &&
                                    this.filterFormStore.getValue('level') != "federal_constituency" &&
                                    this.filterFormStore.getValue('level') != "polling_unit" &&
                                    this.filterFormStore.getValue('level') != "state_constituency" ?
                                    <Col md={2}>
                                        <Field
                                            key={'filer-state-dp' +
                                                this.filterFormStore.getValue('election_id') +
                                                this.filterFormStore.getValue('user_party_id') +
                                                this.filterFormStore.getValue('election_position_id')
                                            }
                                            name="state_id"
                                            placeholder="Select State"
                                            component={Select}
                                            loadOptions={() => {
                                                return api.state.getListAction({
                                                    filters: {
                                                        election_id: this.election ? this.election.id : this.filterFormStore.getValue('election_id'),
                                                        election_position_id: this.filterFormStore.getValue('election_position_id'),
                                                        party_id: this.filterFormStore.getValue('user_party_id'),
                                                        level: this.filterFormStore.getValue('level'),
                                                        candidateIds: this.filterFormStore.getValue('candidateIds'),
                                                    }
                                                });
                                            }}
                                            store={this.filterFormStore}
                                            onChange={() => {
                                                this.filterFormStore.setValue('senatorial_district_id', null);
                                                this.filterFormStore.setValue('federal_constituency_id', null);
                                                this.filterFormStore.setValue('local_government_area_id', null);
                                                this.filterFormStore.setValue('state_constituency_id', null);
                                                this.filterFormStore.setValue('ward_id', null);
                                            }}
                                        />
                                    </Col> : ''}

                                {
                                    this.filterFormStore.getValue('level') ?
                                        <>
                                            {this.senatorialDistrictDropDown()}

                                            {this.federalConstituencyDropDown()}
                                        </> : ''
                                }
                                {
                                    this.filterFormStore.getValue('level') &&
                                    this.filterFormStore.getValue('level') !== 'state_constituency' &&
                                    this.filterFormStore.getValue('level') !== 'polling_unit'  ?
                                        <Col md={2}>
                                            <Field
                                                key={'filter-lga-id' +
                                                this.filterFormStore.getValue('election_id') +
                                                this.filterFormStore.getValue('election_position_id') +
                                                this.filterFormStore.getValue('user_party_id') +
                                                this.filterFormStore.getValue('state_id') +
                                                this.filterFormStore.getValue('senatorial_district_id') +
                                                this.filterFormStore.getValue('federal_constituency_id')
                                                }
                                                name="local_government_area_id"
                                                placeholder="Select LGA"
                                                component={Select}
                                                loadOptions={() => {
                                                    return api.localGovernmentArea.getListAction({
                                                        filters: {
                                                            election_id: this.election ? this.election.id : this.filterFormStore.getValue('election_id'),
                                                            state_id: this.filterFormStore.getValue('state_id'),
                                                            senatorial_district_id: this.filterFormStore.getValue('senatorial_district_id'),
                                                            federal_constituency_id: this.filterFormStore.getValue('federal_constituency_id'),
                                                            election_position_id: this.filterFormStore.getValue('election_position_id'),
                                                            level: this.filterFormStore.getValue('level'),
                                                            party_id: this.filterFormStore.getValue('user_party_id'),
                                                            candidateIds: this.filterFormStore.getValue('candidateIds'),
                                                        }
                                                    });
                                                }}
                                                store={this.filterFormStore}
                                                onChange={() => {
                                                    this.filterFormStore.setValue('ward_id', null);
													
                                                }}
                                            />
                                        </Col> : ''
                                }

                                {
                                    this.filterFormStore.getValue('level') &&
                                    this.filterFormStore.getValue('level') === 'state_constituency' ?
                                        <>
                                            {this.stateConstituencyDropDown()}
                                        </> : ''
                                }
                                
                                {
                                    this.filterFormStore.getValue('level') &&
                                    <Col md={2}>
                                        <Field
                                            key={"filter-ward-id" +
                                            this.filterFormStore.getValue('election_id') +
                                            this.filterFormStore.getValue('election_position_id') +
                                            this.filterFormStore.getValue('user_party_id') +
                                            this.filterFormStore.getValue('level') +
                                            this.filterFormStore.getValue('state_id') +
                                            this.filterFormStore.getValue('local_government_area_id') +
                                            this.filterFormStore.getValue('state_constituency_id')
                                            }
                                            name="ward_id"
                                            placeholder="Select Ward"
                                            component={Select}
                                            loadOptions={() => {
                                                return api.ward.getListAction({
                                                    filters: {
                                                        state_id: this.filterFormStore.getValue('state_id'),
                                                        local_government_area_id: this.filterFormStore.getValue('local_government_area_id'),
                                                        state_constituency_id: this.filterFormStore.getValue('state_constituency_id'),
                                                        election_position_id: this.filterFormStore.getValue('election_position_id'),
                                                        level: this.filterFormStore.getValue('level'),
                                                        party_id: this.filterFormStore.getValue('user_party_id'),
                                                        candidateIds: this.filterFormStore.getValue('candidateIds'),
                                                        no_position: ( this.filterFormStore.getValue('level') === 'polling_unit') ? 1 : null,
                                                    }
                                                });
                                            }}
                                            store={this.filterFormStore}
                                        />
                                    </Col>
                                }
                                

                            </> : ''
                    }
                    <Col md={2} lg={3} xl className="grid-search">
                        {this.renderSearch()}
                    </Col>
					
                </Row>
            </Container>
        );
    }
}

export class PartyElectionPollingUnitPage extends CrudPage {
    modelName = 'PartyElectionPollingUnit';
    actionButton = false;
}



// WEBPACK FOOTER //
// ./resources/js/components/pages/PartyElectionPollingUnitPage.tsx